import React from "react";
import FormattedMessage from "components/FormattedMessage";
import { Field } from "redux-form";
import { Box, Flex, Input, MaskedInput } from "ui-components";
import FieldError from "./FieldError";
import Label from "./Label";
import isFunction from "lodash/isFunction";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { handleRelatedTargetAfterBlur, safeEval } from "utils/helpers";

const renderField = ({
  input,
  label,
  type,
  placeholder,
  readOnly,
  disabled,
  mask,
  meta: { touched, error }
}) => {
  const handleInputOnBlur = (event, newValue, previousValue, name) => {
    if (isFunction(input.onBlur)) {
      input.onBlur(event, newValue, previousValue, name);
    }
    handleRelatedTargetAfterBlur(event);
  };

  const handleMaskInputOnBlur = (event, value) => {
    if (isFunction(input.onBlur)) {
      input.onBlur(value || event);
    }

    handleRelatedTargetAfterBlur(event);
  };

  const inputRenderer = msg => {
    const InputElement = !isEmpty(mask) ? MaskedInput : Input;
    const onBlurHandler = !isEmpty(mask)
      ? handleMaskInputOnBlur
      : handleInputOnBlur;

    return (
      <InputElement
        {...input}
        {...(msg && { placeholder: msg })}
        placeholder={msg}
        type={type}
        autoComplete="off"
        onBlur={onBlurHandler}
        readOnly={readOnly}
        disabled={disabled}
        {...(!isEmpty(mask) && { ...mask })}
      />
    );
  };

  return (
    <>
      {label && (
        <label>
          <FormattedMessage id={label} />
        </label>
      )}

      {placeholder ? (
        <FormattedMessage id={placeholder}>
          {msg => inputRenderer(msg)}
        </FormattedMessage>
      ) : (
        inputRenderer()
      )}

      <FieldError touched={touched} error={error} />
    </>
  );
};

const PhoneField = props => {
  const {
    field,
    label,
    placeholder,
    normalize,
    required,
    optional,
    data,
    disabled,
    formValues,
    generic,
    readOnly
  } = props;
  const isDisabled = safeEval(get, formValues, disabled, false, props);
  const hideCountryCode = get(
    generic,
    "contact_number.hide_country_code",
    false
  );
  const genericMask = get(generic, "contact_number.mask");
  const contactNumberMask = data?.mask || genericMask;

  return !field ? null : (
    <Box mb={8} style={data?.style || {}}>
      {label && (
        <Label
          label={<FormattedMessage id={label} />}
          formValues={formValues}
          required={required}
          optional={optional}
          messageData={formValues}
          {...data}
        />
      )}

      <Flex mx={-2}>
        {!hideCountryCode && (
          <Box width={1 / 4} px={2} data-testid={"country_code"}>
            <Field name="country_code" component={renderField} readOnly />
          </Box>
        )}
        <Box width={3 / 4} px={2} data-testid={field}>
          <Field
            name={field}
            readOnly={readOnly}
            component={renderField}
            placeholder={placeholder}
            normalize={normalize}
            disabled={isDisabled}
            mask={contactNumberMask}
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default PhoneField;
